// extracted by mini-css-extract-plugin
module.exports = {"text":"ExpandableDescription-module__text--19sMv","title":"ExpandableDescription-module__title--wSUNc","description":"ExpandableDescription-module__description--W1JmK"};